import { useQuery } from 'react-query';

import { Category } from '../../../types/Category';
import { PaginatedList } from '../../../types/PaginatedList';
import Api from '../../api/api';

export type GetSubCategoryDto = {
  page?: number;
  limit?: number;
  search?: string;
  published?: boolean;
};

const getSubCategoriesByCategory = async (categoryId: string, params: GetSubCategoryDto): Promise<PaginatedList<Category>> => {
  const [response, bodyOrError] = await Api.get(`web/categories/${categoryId}/sub-categories`, { ...params });

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetSubCategoriesByCategory = (categoryId: string, params: GetSubCategoryDto) => {
  return useQuery(['getSubCategoriesByCategory', categoryId, params], () => getSubCategoriesByCategory(categoryId, params), {
    enabled: !!categoryId,
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};
